import { forwardRef } from "react";
import moneyIconSrc from "@/assets/money.svg";

interface MoneyIconProps {
  size?: number;
  className?: string;
}

const MoneyIcon = forwardRef<HTMLImageElement, MoneyIconProps>(
  ({ size = 16, className = "" }, ref) => {
    return (
      <img 
        ref={ref}
        src={moneyIconSrc} 
        alt="Money" 
        width={size} 
        height={size}
        className={className}
        style={{ 
          imageRendering: 'pixelated',
          width: size,
          height: size,
          aspectRatio: '1 / 1',
          display: 'block'
        }}
      />
    );
  }
);

MoneyIcon.displayName = 'MoneyIcon';

export default MoneyIcon;
